import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { clearCache } from "@/lib/cache";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() =>
        api
          .post("/auth/refresh")
          .then((r) => setUser(r.data))
          .catch(() => setUser(false))
      )
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    clearCache();
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      /* ignore */
    }
    clearCache();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, setUser, isPlanner: user && user.role === "planner" }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
